import Modal from 'flowbite/lib/esm/components/modal'
import { stimulus } from '~/init'

stimulus.register('turbo-confirm', Modal)
